<template>
  <div id="contenedor-registrar-detalle-reporte">
    <v-card>
      <v-card-title>
        Registrar reporte # {{ getReporteFisico.numero }}
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-4" />
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="7">
            <v-row>
              <custom-date-picker
                cols="12"
                md="6"
                v-model="getReporteFisico.fecha"
                label="Fecha Contrato"
                disabled>
              </custom-date-picker>
              <custom-select
                cols="12"
                md="6"
                v-model="getReporteFisico.calidad"
                label="Calidad de los trabajos"
                :items="calidadTrabajos"
                itemText="text"
                itemValue="id"
                disabled>
              </custom-select>
              <custom-text-area
                cols="12"
                class="pb-1"
                v-model="getReporteFisico.comentarios"
                label="Comentarios"
                autoGrow
                disabled>
              </custom-text-area>
            </v-row>
          </v-col>
          <v-col cols="12" md="5">
            <v-row justify="center">
              <v-col cols="auto">
                <v-checkbox
                  v-model="getReporteFisico.existeProblema"
                  hide-details
                  class="my-3"
                  label="Existe algún problema?"
                  disabled>
                </v-checkbox>
              </v-col>
              <custom-text-area
                cols="12"
                class="pb-1"
                v-model="getReporteFisico.descripcionProblema"
                label="Comentarios"
                disabled
                autoGrow>
              </custom-text-area>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-card flat color="brown lighten-5">
              <v-card-title>Avances</v-card-title>
              <v-card-text>
                <v-row>
                  <custom-text-field
                    cols="12"
                    md="4"
                    v-model.number="getReporteFisico.avanceFisico"
                    label="Fisico"
                    type="number"
                    prefix="%"
                    disabled>
                  </custom-text-field>
                  <custom-text-field
                    cols="12"
                    md="4"
                    v-model.number="getReporteFisico.avanceProgramado"
                    label="Programado"
                    type="number"
                    prefix="%"
                    disabled>
                  </custom-text-field>
                  <custom-text-field
                    cols="12"
                    md="4"
                    v-model.number="getReporteFisico.avanceFinanciero"
                    label="Financiero"
                    type="number"
                    prefix="%"
                    disabled>
                  </custom-text-field>
                  <custom-text-field
                    v-model="porcentajeAtraso"
                    cols="12"
                    md="4"
                    :label="tituloPorcentajeAtraso"
                    readonly
                    prefix="%">
                  </custom-text-field>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card flat color="blue-grey lighten-5">
              <v-card-title>Partidas</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-row justify="space-between">
                      <v-expansion-panels>
                        <v-expansion-panel
                          v-for="(partida, i) in getReportePartidas"
                          :key="i">
                          <v-expansion-panel-header>
                            <v-row>
                              <v-col cols="7">
                                <span>{{ partida.concepto }}</span>
                              </v-col>
                              <v-col cols="3" class="py-1">
                                <v-chip
                                  v-if="partida.imagenes && partida.imagenes.length > 0"
                                  color="light-blue"
                                  class="mr-2">
                                  <v-icon class="light-blue--text text--lighten-5 mr-1">
                                    collections
                                  </v-icon>
                                  <b class="light-blue--text text--lighten-5">
                                    {{ partida.imagenes.length }}
                                  </b>
                                </v-chip>
                                <v-chip
                                  v-if="Boolean(partida.avanceFisico)"
                                  color="orange">
                                  <v-icon class="orange--text text--lighten-5 mr-1">
                                    trending_up
                                  </v-icon>
                                  <b class="orange--text text--lighten-5">
                                    {{ `${partida.avanceFisico || 0}%` }}
                                  </b>
                                </v-chip>
                                <v-chip
                                  v-if="Boolean(partida.comentario)"
                                  color="purple"
                                  class="ml-2">
                                  <v-icon class="purple--text text--lighten-5">
                                    chat
                                  </v-icon>
                                </v-chip>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <custom-text-area
                                cols="12"
                                class="pb-1"
                                v-model="partida.comentario"
                                label="Comentarios"
                                autoGrow
                                disabled>
                              </custom-text-area>
                              <v-col cols="12">
                                <v-card flat color="light-blue lighten-5">
                                  <v-card-subtitle>Fotos</v-card-subtitle>
                                  <v-card-text class="pt-2">
                                    <v-row justify="center">
                                      <v-col
                                        cols="auto"
                                        class="pa-1"
                                        v-for="publicKey in partida.imagenes"
                                        :key="publicKey">
                                        <show-thumbnail :publicKey="publicKey" />
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="cerrar">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import ShowThumbnail from '@/components/inputs/ShowThumbnail.vue';

export default {
  name: 'DetallesReporteFisico',
  components: {
    CustomSelect,
    CustomTextField,
    CustomTextArea,
    CustomDatePicker,
    ShowThumbnail,
  },
  props: {
    reporteFisico: Object,
  },
  apollo: {
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  data() {
    return {
      urlUploadImg: 'http://localhost:3001/multiples-imagenes',
      searchConcepto: '',
      calidadTrabajos: [
        { id: 1, text: 'BUENA' },
        { id: 2, text: 'REGULAR' },
        { id: 3, text: 'MALA' },
      ],
    };
  },
  mounted() {},
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    getFotos(id) {
      const objFotos = this.fotos.find((item) => item.id === id);
      if (!objFotos) return [];
      return objFotos.fotos;
    },
    getFotosPartida(partida) {
      const { imagenes } = partida;
      if (!imagenes || !imagenes.fotos) return [];
      return imagenes.fotos;
    },
  },
  computed: {
    getReporteFisico() {
      if (!this.reporteFisico) return {};
      return this.reporteFisico;
    },
    getCatalogoConceptos() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos
        .slice()
        .sort((a, b) => a.orden - b.orden);
    },
    getReportePartidas() {
      return this.getReporteFisico.partidas.map((item) => {
        const partida = this.getCatalogoConceptos.find((elem) => elem.id === item.idPartida);
        // console.log({ item, partida });
        if (!partida) return {};
        const {
          avanceFisico,
          comentario,
          imagenes,
        } = item;
        let fotos = [];
        if (imagenes) {
          fotos = JSON.parse(imagenes);
        }
        return {
          concepto: partida.concepto,
          avanceFisico,
          comentario,
          imagenes: fotos,
        };
      });
    },
    porcentajeAtraso() {
      const { avanceFisico, avanceProgramado } = this.getReporteFisico;
      if (avanceProgramado <= 0 || avanceFisico <= 0) return 0;
      return this.$numberRoundDigits((avanceProgramado - avanceFisico), 2);
    },
    tituloPorcentajeAtraso() {
      if (this.porcentajeAtraso < 0) return 'Atraso';
      return 'A tiempo';
    },
  },
  // watch: {
  //   getCatalogoConceptos: {
  //     handler() {
  //       this.fetchPartidas();
  //     },
  //     deep: true,
  //   },
  // },
};
</script>

<style lang="scss">

</style>
